import { nativeApi } from '@/../../common/src/utils/nativeApi';
import { ReactComponent as CloseSvg } from '@/images/cross.svg';
import { captureException } from '@web/common';
import { Empty } from 'rc-ui-lib';
import { Component, ErrorInfo, ReactNode } from 'react';
import type { BaseComponentProps } from '..';

type State = {
  hasError: boolean;
};

class PageErrorBoundary extends Component<BaseComponentProps, State> {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.log({
      error,
      info,
    });
    this.setState({
      hasError: true,
    });

    if (String(import.meta.env.VITE_APP_STARTSENTRY) === 'true') {
      captureException(error, 2, {
        extra: info,
      });
    }
  }

  render(): ReactNode {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return (
        <>
          <CloseSvg
            style={{
              width: 24,
              height: 24,
              marginTop: 45,
              marginLeft: 29,
              color: 'var(--rc-text-color)',
            }}
            onClick={() => {
              nativeApi.closeWindow();
            }}
          />
          <Empty description="啊哦，頁面出錯哦....." />
        </>
      );
    }
    return children;
  }
}

export default PageErrorBoundary;
